import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
    selector: 'brightside-web-pls-intro',
    templateUrl: './pls-intro.component.html',
    styleUrls: ['./pls-intro.component.scss'],
    standalone: false
})
export class PlsIntroComponent implements OnInit {
  introCtaCopy: string = 'CONTEST_INTRO_CTA1';
  private _origin: string;

  constructor(private _router: Router, private _route: ActivatedRoute, private _location: Location) {}

  get fromSavings(): boolean {
    return this._origin === 'savings';
  }

  ngOnInit(): void {
    this._origin = this._route.snapshot.queryParams['origin'];
    if (this.fromSavings) {
      this.introCtaCopy = 'CONTEST_INTRO_HAS_SAVINGS_CTA1';
    }
  }

  contestIntroClick(): void {
    if (this.fromSavings) {
      this._router.navigate(['../autosave-select'], { relativeTo: this._route });
    } else {
      this._router.navigate(['accounts/savings']);
    }
  }

  showRules(): void {
    this._router.navigate(['../contest-rules'], { relativeTo: this._route });
  }
}
